import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useTasksListStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
    searchField: {
      marginBottom: '30px',
      width: '100%',
    },
    gridList: {
      width: '100%',
    },
    formControl: {
      width: '100%',
      marginTop: theme.typography.pxToRem(16),
      marginBottom: theme.typography.pxToRem(8),
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '4px',
    },
    chip: {
      margin: 2,
    },
  })
);
